import { creator as actionCreator } from 'uwork-app-core';

/**
 * Action Types
 */
export const actionTypes = {
    REMOVE: '@app/errors/REMOVE',
    RESET: '@app/errors/RESET'
};

/**
 * Init state
 */
export const initState = {};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
export default function (state = initState, { type, payload }) {
    /*
     * Reset state
     */
    if (type === actionTypes.RESET) {
        return initState;
    }

    /*
     * Remove single action
     */
    if (type === actionTypes.REMOVE) {
        const { [payload]: value, ...removedState } = state;
        return removedState;
    }

    const isSuccess = type.includes('SUCCESS');
    const isRequest = type.includes('REQUEST');
    const isClear = type.includes('CLEAR');
    const isFailure = type.includes('FAILURE');

    if (isFailure) {
        console.error(type, payload);
        return { ...state, [type]: payload };
    }

    if (isRequest || isSuccess || isClear) {
        const { [type.replace(/SUCCESS|REQUEST|CLEAR/, 'FAILURE')]: value, ...restState } = state;

        return restState;
    }

    return state;
}

/**
 * Redux actions
 */
export const errorsActions = {
    remove: actionCreator(actionTypes.REMOVE),
    reset: actionCreator(actionTypes.RESET)
};
